import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from "react-router-dom";
import AddUserRequestQuote from './AddUserRequestQuote';
import EditUserRequestQuote from './Modal/EditUserRequestQuote';
import DeleteUserRequestQuote from './Modal/DeleteUserRequestQuote';
import UserMakePayment from './Modal/UserMakePayment';
import { IconEdit, IconTrash } from '@tabler/icons-react';
import axios from "axios";
import Countdown from 'react-countdown';
import Loader from "../../Loader.jsx"
import { useSelector } from "react-redux";
import { toast } from 'react-toastify';

const Userrequestquote = () => {
  const [loader, setLoader] = useState(false);
  const [addModalShow, setAddModalShow] = useState(false);
  const [editModalShow, setEditModalShow] = useState(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [MakePaymentModalShow, setMakePaymentModalShow] = useState(false);
  const [quotations, setQuotations] = useState([]);
  const [pagination, setPagination] = useState({ limit: 10, skip: 0, nextPage: null, currentPage: null, previousPage: null });
  const [quotationId, setQuotationId] = useState(null);
  const [oldData, setOldData] = useState({});
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.token);
  const navigate = useNavigate();

  const GetQuotation = () => {
    setLoader(true);
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_BASE_URL}/quotation/user/${user._id}?limit=${pagination.limit}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      }
    }).then(res => {
      setLoader(false);
      setQuotations(res.data.quotations);
      setPagination((pre) => ({
        ...pre,
        currentPage: res.data.currentPage,
        nextPage: res.data.nextPage,
        previousPage: res.data.previousPage
      }));
    }).catch(err => {
      setLoader(false);
    });
  }

  const Status = (status) => {
    if (status === "Quote provided") {
      return <p className='text-success'>{status}</p>
    } else if (status === "Ordered") {
      return <p className='text-secondary'>{status}</p>
    } else if (status === "Expired") {
      return <p className='text-danger'>{status}</p>
    } else {
      return <p className='text-info'>{status}</p>
    }
  }

  useEffect(() => {
    GetQuotation();
  }, []);

  return (
    <>
      <section className="user_main">
        <Container fluid>
          <Row className='d-flex justify-content-center flex-column-reverse flex-lg-row mb-5'>
            <AddUserRequestQuote onSubmit={GetQuotation}/>
          </Row>
          <Row>
            <Col md={12}>
              <Card>
                <Card.Header as="h5">
                  <div className="d-flex align-items-center justify-content-between gap-3">
                    <div className="head_title">
                      <h3 className="mb-0">Quotations</h3>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body>
                  {quotations?.length > 0 ?
                    <div className="table-responsive">
                      <table className="client_table">
                        <thead>
                          <tr className="d-none d-lg-table-row">
                          <th width="18%">Date</th>
                          <th width="18%">Service type</th>
                          <th width="6%">Currency</th>
                          <th width="10%">Recipient amount</th>
                          <th width="10%">Recipient currency</th>
                          <th width="10%">Status</th>
                          <th width="8%">Rate</th>
                          <th width="8%">Sub total</th>
                          <th width="8%">Additional fee</th>
                          <th width="8%">Estimate total</th>
                          <th width="10%">Expire on</th>
                          <th className='text-end' width="10%">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {quotations.map((q, index) => {
                          return (<tr key={index} className="tr">
                            <td>
                              <strong className="ht">Date : </strong>
                              <small>{`${new Date(q.createdAt).toLocaleString()}`}</small>
                            </td>
                            <td>
                              <strong className="ht">Service type : </strong>
                              <small>{q.serviceType}</small>
                            </td>
                            <td>
                              <strong className="ht">Currency : </strong>
                              <small>{q?.currency?.toUpperCase()}</small>
                            </td>
                            <td>
                              <strong className="ht">Recipient amount : </strong>
                              <small>{parseFloat(q?.recipientAmount) > 0.01 ? parseFloat(q?.recipientAmount).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(q?.recipientAmount) }</small>
                            </td>
                            <td>
                              <strong className="ht">Recipient currency : </strong>
                              <small>{q?.recipientCurrency.toUpperCase()}</small>
                            </td>
                            <td>
                              <strong className="ht">Status : </strong>
                              <small>{Status(q.status)}</small>
                            </td>
                            <td>
                              <strong className="ht">Rate: </strong>
                              <small>{q.recipientCurrency === "ngn" ? q.displayRate ? parseFloat(q.displayRate) > 0.01 ? parseFloat(q.displayRate).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(q.displayRate) : "-" : q.rate ? parseFloat(q.rate) > 0.01 ? parseFloat(q.rate).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(q.rate) : "-"}</small>
                            </td>
                            <td>
                              <strong className="ht">Sub total : </strong>
                              <small>{q?.subTotal ? parseFloat(q.subTotal) > 0.01 ? parseFloat(q.subTotal).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(q.subTotal) : "-"}</small>
                            </td>
                            <td>
                              <strong className="ht">Additional fee : </strong>
                              <small>{q?.additionalFee ? parseFloat(q.additionalFee) > 0.01 ? parseFloat(q.additionalFee).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(q.additionalFee) : "-"}</small>
                            </td>
                            <td>
                              <strong className="ht">Estimate total : </strong>
                              <small>{q?.estimateTotal ? parseFloat(q.estimateTotal) > 0.01 ? parseFloat(q.estimateTotal).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(q.estimateTotal) : "-"}</small>
                            </td>
                            <td>
                              <strong className="ht">Expire on : </strong>
                              <small>
                                {q.expireDate ?
                                  <Countdown
                                    autoStart
                                    date={new Date(q.expireDate)}
                                  />
                                  : "-"}
                              </small>
                            </td>
                            <td>
                              <strong className="ht">Action : </strong>
                              <small className="d-flex justify-content-end gap-2">
                                {!q.expireDate ?
                                  <>
                                    <Button disabled={!q.expireDate ? false : true} className="button blue p-1" variant="primary" onClick={() => {
                                      setQuotationId(q._id);
                                      return setEditModalShow(true);
                                    }}>
                                      <IconEdit size={24} stroke={2} />
                                    </Button>
                                    <Button disabled={!q.expireDate ? false : true} className="button red p-1" variant="primary" onClick={() => {
                                      setQuotationId(q._id);
                                      return setDeleteModalShow(true);
                                    }}>
                                      <IconTrash size={24} stroke={2} />
                                    </Button>
                                  </>
                                  :
                                  <>
                                    {q.expireDate && q.status != "Ordered" && new Date() < new Date(q?.expireDate) ?
                                      <Button style={{whiteSpace: "nowrap"}}
                                      disabled={q.expireDate && q.status != "Ordered" && new Date() < new Date(q?.expireDate) ? false : true}
                                      className='button blue' variant="primary" onClick={() => {
                                        navigate(`/receiverdetails/${q._id}`);
                                      }}>Order now</Button>:
                                      <small>-</small>
                                    }
                                  </>}
                              </small>
                            </td>
                          </tr>)
                        })}
                        </tbody>
                      </table>
                    </div>
                    : <p>Quotation not found</p>}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      <EditUserRequestQuote
        show={editModalShow}
        quotationId={quotationId}
        data={oldData}
        getData={() => GetQuotation()}
        onHide={() => setEditModalShow(false)}
      />
      <DeleteUserRequestQuote
        show={deleteModalShow}
        getData={() => GetQuotation()}
        quotationId={quotationId}
        onHide={() => setDeleteModalShow(false)}
      />
      <Loader show={loader}/>
    </>
  )
}

export default Userrequestquote